const formatDateWithTimezone = (dateString: string) => {
  const [datePart, timePart, timezone] = dateString.split(' ');

  const timeParts = timePart.split('.');
  const timeMainPart = timeParts[0];
  const timezoneOffset = `${timezone.substring(0, 3)}:${timezone.substring(3)}`;

  const dateTimeISO = `${datePart}T${timeMainPart}${timezoneOffset}`;

  const date = new Date(dateTimeISO);

  const offsetInMinutes = date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetInMinutes) / 60);
  const offsetMinutes = Math.abs(offsetInMinutes) % 60;

  const totalHours = date.getHours() + (offsetInMinutes >= 0 ? -offsetHours : offsetHours);
  const totalMinutes = date.getMinutes() + (offsetInMinutes >= 0 ? -offsetMinutes : offsetMinutes);

  date.setHours(totalHours);
  date.setMinutes(totalMinutes);

  return date.toISOString().slice(0, 16).replace('T', ' ');
};

export { formatDateWithTimezone };
